export function scrollToElementBottom(element: HTMLElement, offset = 0): void {
  const root = document.getElementById('root') as HTMLDivElement;
  const rect = element.getBoundingClientRect();
  const y = root.scrollTop + rect.bottom - window.innerHeight + offset;
  root.scrollTo(0, y);
}
